import type { OwaDate } from '../../../schema';
import getIntlDateLunar from '../lunar/getIntlDateLunar';
import { LunarCalendarType } from '../lunar/LunarCalendarType';

const leapMonthCharacter = '閏';

const days: string[] = [
    '', // Never used since the first day of the month shows the month name
    '二',
    '三',
    '四',
    '五',
    '六',
    '七',
    '八',
    '九',
    '十',
    '十一',
    '十二',
    '十三',
    '十四',
    '十五',
    '十六',
    '十七',
    '十八',
    '十九',
    '二十',
    '二十一',
    '二十二',
    '二十三',
    '二十四',
    '二十五',
    '二十六',
    '二十七',
    '二十八',
    '二十九',
    '三十',
];

const months: string[] = [
    '正月', // Never used since the first day of the month shows the month name
    '二月',
    '三月',
    '四月',
    '五月',
    '六月',
    '七月',
    '八月',
    '九月',
    '十月',
    '十一月',
    '十二月',
];

export default function getIntlDateJapaneseLunar(date: OwaDate): string {
    return getIntlDateLunar(date, LunarCalendarType.Japanese, {
        days: days,
        months: months,
        leapMonthCharacter: leapMonthCharacter,
    });
}
